/* 
【dAgora】作家コレクション＆作家コレクション一覧ページ用JS
 1.作家プロフィールの成形用JS
ver管理
1.0 : 25/07/10 dAgora
*/

/* 1.作家プロフィールの成形用JS */
document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll('[data-career="true"]').forEach(container => {
    const lines = container.innerText
      .replace(/\u2028|\u2029/g, '\n') // Unicode改行対応
      .replace(/\r\n|\r/g, '\n')      // OS依存の改行にも対応
      .split('\n');

    const html = lines.map(line => {
      if (line.includes("|")) {
        const [yearRaw, contentRaw] = line.split("|");
        const year = yearRaw ? yearRaw.trim() : "";
        const content = contentRaw ? contentRaw.trim() : "";

        const yearHtml = year
          ? `<span class="career-year">${year}</span>`
          : `<span class="year-null"></span>`;

        return `<p class="career-paragraph">${yearHtml}<br class="br-sp"><span class="career-detail">${content}</span></p>`;
      } else {
        // パイプなしの行はそのまま出力
        return `<p class="career-paragraph">${line.trim()}</p>`;
      }
    }).join("");

    container.innerHTML = html;
  });
});
